import { createContextScope } from "@tamagui/create-context";
const SLIDER_NAME = "Slider";
const [createSliderContext, createSliderScope] = createContextScope(SLIDER_NAME);
const [SliderProvider, useSliderContext] = createSliderContext(SLIDER_NAME);
const [SliderOrientationProvider, useSliderOrientationContext] = createSliderContext(SLIDER_NAME, {
  startEdge: "left",
  endEdge: "right",
  sizeProp: "width",
  size: 0,
  direction: 1
});
const PAGE_KEYS = ["PageUp", "PageDown"];
const ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
const BACK_KEYS = {
  ltr: ["ArrowDown", "Home", "ArrowLeft", "PageDown"],
  rtl: ["ArrowDown", "Home", "ArrowRight", "PageDown"]
};
export {
  ARROW_KEYS,
  BACK_KEYS,
  PAGE_KEYS,
  SLIDER_NAME,
  SliderOrientationProvider,
  SliderProvider,
  createSliderContext,
  createSliderScope,
  useSliderContext,
  useSliderOrientationContext
};
//# sourceMappingURL=constants.js.map
